export default __webpack_public_path__ + "static/media/Mastery Demands Focus_icon.01672fe6.gif";